<template>
  <div class="paginator">
    <div class="md-layout">
      <div class="md-layout-item p10">
        <!-- <md-field v-if="template" class="md-field-select">
          <label>Assessment</label>
          <md-select class="assessment-type" v-model="temp">
            <md-option
              :key="template.id"
              :value="template.id"
              v-for="template in templateOptions"
              >{{ template.label }}</md-option
            >
          </md-select>
        </md-field> -->
        <md-autocomplete v-if="template" class="students" :class="errorClass" v-model="templateObj" :md-options="getSanitizedTemplates(templateOptions)" >
          <label>Assessment Template</label>
          <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
          <span class="md-error">Please fill assessment type</span>
        </md-autocomplete>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssessmentTypeSelect",
  props: ['variation', 'error-class'],
  computed: {
    templateOptions() {
      let templates = this.templateTree.filter((el)=>{
        return el.variation == this.variation;
      });
      return templates;
    }
  },
  mounted() {
    this.$apollo
      .query({
        query: require("../graphql/Templates.gql"),
        fetchPolicy: "no-cache",
        variables: {
          filter: {
            status: true,
          }
        }
      })
      .then((data) => {
        let templates = {};
        let parseTemplate = (template) => {
          templates[template.id] = template;
          if (template.childrens) {
            template.childrens.forEach((el) => {
              parseTemplate(el);
            });
          }
        };
        data.data.templates.edges.forEach((el) => {
          parseTemplate(el);
        });
        data.data.templates.edges;
        this.template = true;
        this.templates = templates;
        this.templateTree = data.data.templates.edges;
        // if (this.templateOptions.length) {
        //   this.type = this.templateOptions[0].type;
        //   this.temp = this.templateOptions[0].id;
        //   // this.templateObj = this.getSanitizedTemplates(this.templateOptions)[0];
        // }
      });
  },
  data() {
    return {
      templateTree: null,
      template: false,
      templates: null,
      temp: {},
      type: null,
      templateObj: {id:'-', name: '', toLowerCase:()=>{return ''}, toString:()=>{return ''}},
    }
  },
  methods: {
    getSanitizedTemplates(options) {
      return options.map(item => ({
        'id': item.id,
        'name': item.label,
        'toLowerCase': () => item.label.toLowerCase(),
        'toString': () => item.label
      }));
    },
  },
  watch: {
    templateObj() {
      if (this.templateObj.id) {
        let template = this.templates[this.templateObj.id];
        this.$emit('input', template.type);
        this.$emit('template', template);
      }
      else {
        this.$emit('input', null);
        this.$emit('template', null);
      }
    },
    temp() {
      let template = this.templates[this.temp];
      this.$emit('input', template.type);
      this.$emit('template', template);
    }
  }
}
</script>
<style lang="scss" scoped>
.students {
  min-width: 600px;
}
</style>